<!--
 * @Author: ldx
 * @Date: 2022-10-14 09:31:48
 * @LastEditors: ldx
 * @LastEditTime: 2022-11-28 08:56:30
 * @Description:  授课助手-用户协议
-->
<template>
  <div class="page-container">
    <h3>用户协议</h3>
    <p>
      尊敬的用户，欢迎使用由东莞市安道光电材料制造有限公司提供的服务。本协议是用户与东莞市安道光电材料制造有限公司之间关于安道授课助手app在使用时所订立的协议。“安道”是指安道授课助手app的开发、运营、管理及宣传主体（在本协议更多地称为“我们”），“用户”是指安道授课助手app的使用人（在本协议更多地称为“您”）。在使用前请用户阅读如下服务协议，使用本应用即表示用户同意接受本协议，本协议产生法律效力，特别涉及免除或者限制安道责任的条款及对用户的权利限制条款、隐私保护、账户规则、法律适用和争议解决条款，请仔细阅读并接受或不接受本协议。如有任何问题，可向安道咨询。
    </p>
    <p>1. 服务条款的确认和接受</p>
    <p>通过访问或使用本应用，表示您同意接受本协议的所有条件和条款。</p>
    <p>2. 服务条款的变更和修改</p>
    <p>
      考虑到互联网服务以及产品频繁迭代更新等行业特点，我们可以对其提供的服务予以随时变更，服务条款一旦发生变更，将会在重要页面上提示修改内容。我们将通过包括但不限于制定政策、规则、说明、协议、公告声明等形式进行变更告知，更新后的协议条款将替代原来的协议并在法律规定的期限届满后正式生效。如果您不同意所改动的内容，您可以放弃获得的本应用信息服务。如果您继续享用本应用的信息服务，则视为接受服务条款的变更。
    </p>
    <p>3. 用户行为</p>
    <p>3.1 用户账号、密码和安全</p>
    <p>
      （1）您需注册账号才可使用该软件产品功能，您应通过您拥有合法使用权的手机号码\已有的账号等方式登录使用。您有责任妥善保管帐号的用户名和密码等信息，如果您发现有人未经授权使用其的帐号信息或怀疑任何人未经授权可能能够访问其的私有内容，您应立即更改密码，并通知我们的客户服务团队
    </p>
    <p>
      （2）您充分了解并同意，您必须为自己账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用本服务及其内容而引起的所有风险，包括因对本服务及其内容的正确性、完整性或实用性的依赖而产生的风险。安道无法且不会对因前述风险而导致的任何损失或损害承担责任。
    </p>
    <p>3.2 账号注册时的禁止行为</p>
    <p>（1）请勿以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；</p>
    <p>（2）冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关的名称；</p>
    <p>（3）请勿注册和其他网友之名相近、相仿的名字；</p>
    <p>（4）请勿注册不文明、不健康名字，或包含歧视、侮辱、猥亵类词语的名字；</p>
    <p>（5）请勿注册易产生歧义、引起他人误解的名字；</p>
    <p>3.3 用户在本应用上不得发布下列违法信息和照片：</p>
    <p>（1）反对宪法所确定的基本原则的；</p>
    <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
    <p>（3）损害国家荣誉和利益的；</p>
    <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
    <p>（9）含有法律、行政法规、司法解释、地方法规、地方规章、部门规章及其他规范性文件禁止的其他内容的；</p>
    <p>（10）禁止骚扰、毁谤、威胁、仿冒网站其他您；</p>
    <p>（11）严禁煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
    <p>（12）严禁发布可能会妨害第三方权益的文件或者信息，例如（包括但不限于）：病毒代码、黑客程序、软件破解注册信息。</p>
    <p>（13）禁止上传他人作品。其中包括你从互联网上下载、截图或收集的可能侵害他人合法权益的作品；</p>
    <p>（14）禁止上传广告、横幅、标志等网络图片；</p>
    <p>（15）违反公序良俗、社会公德、安道平台规则或其他主体的合法权益。</p>
    <p>3.4 用户使用本软件的行为应：</p>
    <p>（1） 您通过本服务发送或传播的内容（包括但不限于网页、文字、图片、音频、视频、图表等）均由您自行承担责任；</p>
    <p>（2） 您发送或传播的内容应有合法来源，相关内容为您所有或您已获得必要的授权。</p>
    <p>（3） 您保证对您在投诉处理程序中提供的信息、材料、证据等的真实性、合法性、有效性负责。</p>
    <p>
      3.5
      我们有权基于用户的行为及应适用的规则，并可能借助于大数据分析判断，在认为可能不利于我们提供服务或涉及违法违规情形时，可以先行暂停、中断或终止向用户提供本协议项下的全部或部分帐号服务，包括但不限于：
    </p>
    <p>（1）认为用户不是注册登录的信息主体本人或合法授权人员时；</p>
    <p>（2）发现异常情况或有合理理由怀疑操作有风险或有违法时；</p>
    <p>（3）认为账户存在未经授权的使用或认为有风险之其他情形；</p>
    <p>（4）认为用户已经严重违反本协议中规定的各类规则、规范、指引或用户协议</p>
    <p>4. 服务内容</p>
    <p>
      4.1
      本服务的具体内容由我们根据实际情况提供，可提供包括在使用素材加工、学科工具、思维导图、课堂活动等制作课件、演示课件的基础上，同时为您提供包括但不限于课件云存储、课件分享等功能等服务。
    </p>
    <p>4.2 该软件属于免费应用，您使用过程中，本软件不会以任何方式、名义收取任何费用。</p>
    <p>
      4.3
      为更好地给您提供相关服务，我们将不定期提供本软件及相关服务的更新或改变（包括但不限于软件修改、升级、部分功能停用、功能强化、开发新服务、软件替换等），您可根据需要自行选择是否更新相应的版本。我们将在可行情况下以适当方式（包括但不限于系统提示、公告、站内信、应用商店更新提示等）提示您，您有权选择接受更新后版本；如您选择不作更新，则本软件及相关服务的部分功能将可能受到限制或不能正常使用。
    </p>
    <p>
      4.4
      本软件可能需要您有适配兼容的智能终端及操作系统，否则可能影响本软件以及本服务的稳定兼容性。本软件的内容和功能有可能会根据您所使用的智能终端品牌、型号、操作系统的不同而有所不同或变化。此外，请您通过我们官方网站（http://www.amdolla.com.cn）或经我们授权的第三方渠道获取本软件，否则我们无法保证软件的安全性或适配性，您因此遭受的损失（例如文件受损、丢失）与我们无关。
    </p>
    <p>
      4.5
      若您在使用本软件过程中，不慎受到合法权益的侵犯或者发现存在违法违规或违反本服务相关规则的情况，您也有权向我们发起举报，我们亦会及时采取必要措施（删除、屏蔽、断开链接或限制使用功能等）进行处置。
    </p>
    <p>4.6 除非安道书面许可，您不得从事下列任一行为：</p>
    <p>（1）删除软件及其副本上关于著作权的信息；</p>
    <p>（2）对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；</p>
    <p>（3）对安道拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
    <p>
      （4）对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经安道授权的第三方工具/服务接入软件和相关系统；
    </p>
    <p>
      （5）通过修改或伪造软件运行中的指令、数据等任何方式，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
    </p>
    <p>
      （6）通过非安道开发、授权的第三方软件、插件、外挂、系统、设备等任何方式，登录或使用安道软件及服务，或制作、发布、传播非安道开发、授权的用于登录或使用安道软件及服务的第三方软件、插件、外挂、系统、设备等。
    </p>
    <p>5.第三方关系及管理</p>
    <p>您在本服务上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。安道和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任</p>
    <p>6.所有权及知识产权</p>
    <p>
      6.1
      用户理解并自愿承诺，您主动在本软件发表的任何形式的信息内容（包括但不限于用户评价、用户咨询、各类话题文章等信息内容）的财产性权利将自愿地不可撤销地免费授权给我们及其关联公司供商业性使用，并且您同意我们可基于运营、宣传等合理目的，转授权上述权利。
    </p>
    <p>
      6.2
      由本软件展示的任何文字、图片、软件、声音、视频、录像、图片、音乐等内容的知识产权或相关权益均由安道所有或享有合法权利、获得权利人授权许可。未经安道及相关权利人另行书面授权，您不得以任何形式复制、使用、链接或以其他方式处置或利用这些内容的全部或部分，不得以任何形式侵犯相关权利人的知识产权或权益。
    </p>
    <p>6.3 安道在本服务中所使用的“安道”、“Amdox” 等商标、服务标记、商号、域名、网站名称或其他显著品牌特征（统称为标识），其著作权或商标权归安道所有。</p>
    <p>6.4 基于对本软件数据的合法加工而获得的具有竞争性的数据权益，除法律法规另有规定外，我们享有独立的使用权益而无须获得您的同意。</p>
    <p>6.5 您如需进行商业性的销售、复制、分发，包括但不限于软件销售、预装、捆绑等，必须获得安道的书面使用和许可。</p>
    <p>6.6 上述及其他任何本服务包含的内容的知识产权均受到法律法规保护，未经安道、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。</p>
    <p>6.7 保留权利：本协议未明示使用的其他一切权利仍归安道所有，您使用其他权利时必须获得安道的书面同意。</p>
    <p>7. 隐私政策</p>
    <p>7.1 为了向您提供更稳定的服务，保证您的交易安全，我们会根据本协议以及《用户隐私协议》收集、处理您的个人信息。您可查看并下载《用户隐私协议》。</p>
    <p>
      7.2
      使用本软件的教师应该尊重学生的隐私以及个人信息保护。如果教师违反本协议或者侵犯学生的隐私权和个人信息保护权等合法权益，教师应当自行向学生及其家长承担相应的责任，我们不承担任何的责任。
    </p>
    <p>8. 法律责任及免责条款</p>
    <p>
      8.1
      如果您在使用本软件过程中违反了相关法律法规或本协议约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求安道给予协助。因此给您或者他人造成损害的，您应自行承担全部责任，安道不承担任何责任。
    </p>
    <p>
      8.2
      如果您违反本协议约定，安道有权进行独立判断并采取相应措施，包括但不限于通过技术手段删除、屏蔽相关内容或断开链接等。同时，安道有权视用户的行为性质，采取包括但不限于暂停或终止向您提供服务，限制、中止、冻结或终止您对账号的使用，追究法律责任等措施。
    </p>
    <p>8.3 您违反本协议约定，导致任何第三方主体的索赔、要求或损失的，您应当独立承担责任；安道因此遭受损失的，您也应当一并赔偿</p>
    <p>8.4 您同意并理解安道将会尽其商业上的合理努力保障您在本软件服务中的数据存储安全，但是安道并不能就此提供完全保证，具体详见《免责声明》。</p>
    <p>9.协议变更与终止</p>
    <p>
      如果我们发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，我们有权采取警示、冻结、终止/中止/限制使用帐号、删除信息内容等功能、中止使用许可和/或服务、解除或终止本协议，并提出损害赔偿等措施。
    </p>
    <p>10.法律及争议解决</p>
    <p>10.1 本协议适用中华人民共和国法律。</p>
    <p>10.2 因本协议引起的或与本协议有关的任何争议，各方应友好协商解决；协商不成的，任何一方均可将有关争议提交至安道公司所在地法院管辖。</p>
    <p>11.其他</p>
    <p>
      11.1
      再次提示，我们有权随时根据有关法律、法规的变化以及公司经营状况和经营策略的调整等修改本协议条款。修改后的服务条款将会在本软件网页或客户端、APP运行平台上公布。如果不同意修改的内容，您应停止使用该软件相关功能和技术服务。如果继续使用该等功能和技术服务，则视为您接受本协议条款的变动。
    </p>
    <p>11.2 本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，或违反任何适用的法律，则该条款被视为删除，但本协议的其余条款仍应有效并且有约束力</p>
    <p>11.3 安道可将本协议下的权利和义务部分或全部转让给其他第三方，如果您不同意安道的该转让，则您应停止使用本协议下服务。如果您继续使用，则视您对此予以接受。</p>
    <p>
      至此，用户已经详细阅读并已理解本协议，并同意严格遵守全部条款之约定。如果对本协议有任何疑问或者希望从我们获得任何信息，请按下列地址和方式与客服人员进行直接有效的对接联系,我们将在15个工作日内答复您。
    </p>
    <P>公司：东莞市安道光电材料制造有限公司</P>
    <P>电话：400-632-8880</P>
    <P>联系人：软件客服</P>
    <P>地址：广东省东莞市茶山镇寒溪水新围工业区二路3号4栋101室</P>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  padding: 0 16px;

  h3 {
    font-size: 16px;
    text-align: center;
  }

  p {
    font-size: 14px;
  }
}
</style>
